export default function uniTemplate(info) {
  if (!info) return `No Information Available`;

  const {
    id,
    university,
    totalOffences,
    totalOffencesNotes,
    replied,
    hasData,
    providedOffenceData,
    hasDataNotes,
    providedContinuedStudies,
    continuedStudies,
    continuedStudiesNotes,
    complaintsUpheld,
    policeAction,
    prevEntry,
    nextEntry,
    distancePrevEntry,
    distanceNextEntry,
    hasPolicy
  } = info;


  const to = providedOffenceData ? totalOffences : 'Unknown';
  const cs = providedContinuedStudies ? continuedStudies : 'Unknown';
  const cu = complaintsUpheld.length
    ? complaintsUpheld
    : (providedContinuedStudies === true && continuedStudies === 0)
      ? ''
      : 'Unknown';


  return `
    <div class="info">
      <div class="info-section">
        <div class="info-row">
          <div class="info-section__label">University</div>
          <div class="info-section__header">${university}</div>
        </div>
      </div>

      <div class="info-section">
        <div class="info-row">
          <div class="info-section__label">Total Number of Complaints (2015 - 2018)</div>
          <div class="info-section__header">${to}</div>
        </div>

        ${hasDataNotes !== null ? `
          <div class="info-row">
            <div class="info-section__body info-section__body--small">
              ${hasDataNotes}
            </div>
          </div>
        `: ''}

        ${totalOffencesNotes && `
          <div class="info-row">
            <div class="info-section__body info-section__body--small">
              ${totalOffencesNotes}
            </div>
          </div>
        `}
      </div>

      <div class="info-section">
        <div class="info-row">
          <div class="info-section__label">Number of Alleged Perpetrators Who Continued Studies.</div>
          <div class="info-section__header">${cs}</div>
        </div>

        ${continuedStudiesNotes && `
          <div class="info-row">
            <div class="info-section__body info-section__body--small">
              ${continuedStudiesNotes}
            </div>
          </div>
        `}
      </div>
      
      ${complaintsUpheld && `
        <div class="info-section">
          <div class="info-row">
            <div class="info-section__label">Outcome of Complaints</div>
            <div class="info-section__body">
              ${cu}
            </div>
          </div>
        </div>
      `}

      ${policeAction && `
        <div class="info-section">
          <div class="info-row">
            <div class="info-section__label">Police Action</div>
            <div class="info-section__body">
              ${policeAction}
            </div>
          </div>
        </div>
      `}

      ${hasPolicy && `
        <div class="info-section">
          <div class="info-row">
            <div class="info-section__label">Does the University Have a Policy on Stalking or Domestic Abuse?</div>
            <div class="info-section__body">
              ${hasPolicy}
            </div>
          </div>
        </div>
      `}

      <div class="info-section">
        <div class="info-row clearfix">
          <div class="info-col">
            ${distancePrevEntry ? `
              <div class="info-section__label">Previous</div>
              <div class="info-section__header location-link" data-location-id="${distancePrevEntry.id}">${distancePrevEntry.title}</div>
            ` : ``}
          </div>
          <div class="info-col">
            ${distanceNextEntry ? `
              <div class="info-section__label">Next</div>
              <div class="info-section__header location-link" data-location-id="${distanceNextEntry.id}">${distanceNextEntry.title}</div>
            ` : ``}
          </div>
        </div>
      </div>
    </div>
  `;
}